// Tool icons, drawn by hand as inline SVG. Ink outline, a bit of orange, nothing quite square to the page.

const wrap = (body: string) =>
  `<svg viewBox="0 0 40 40" width="40" height="40" aria-hidden="true" fill="none" stroke="#15110d" stroke-width="2" stroke-linejoin="miter" stroke-linecap="square">${body}</svg>`;

export const ICONS: Record<string, string> = {
  pen: wrap(
    `<path d="M7 33L9 26L28 7L33 12L14 31Z" fill="#efe4cc"/><path d="M25 10L30 15"/><path d="M9 26L14 31"/><path d="M7 33L9 26L14 31Z" fill="#15110d"/>
<path d="M22 35C26 33 29 36 34 34" stroke-width="1.6"/>`),
  ruler: wrap(
    `<g transform="rotate(-35 20 20)"><path d="M3 14L37 14L37 26L3 26Z" fill="#efe4cc"/><path d="M8 14V19M13 14V21M18 14V19M23 14V21M28 14V19M33 14V21" stroke-width="1.6"/></g>`),
  knife: wrap(
    `<path d="M5.5 35L14 26.5" stroke-width="7" stroke="#15110d" stroke-linecap="butt"/><path d="M5.5 35L14 26.5" stroke-width="3.6" stroke="#e8701a" stroke-linecap="butt"/>
<path d="M14 26.5L16 20C21 13 29 8 36 5C34 14 28 22 21 27Z" fill="#efe4cc"/><path d="M16 20L21 27" stroke-width="1.6"/>`),
  fill: wrap(
    `<path d="M6 26L20 12L32 24L18 36Z" fill="#efe4cc"/><path d="M6 26L32 24" stroke-width="1.6"/>
<path d="M20 12L16 6" /><path d="M35 27C35 27 38 31 38 33C38 35 36.5 36 35 36C33.5 36 32 35 32 33C32 31 35 27 35 27Z" fill="#e8701a"/>`),
  saw: wrap(
    `<g transform="rotate(-9 20 20)">
<path d="M3 14.5L27 14.5L27 24.5L24 21.5L21 24.5L18 21.5L15 24.5L12 21.5L9 24.5L6 21.5L3 24.5Z" fill="#efe4cc"/>
<path d="M27 11.5L37.5 12L37 27L27 26.5Z" fill="#e8701a"/><path d="M30.5 16.5L34 16.5L34 22L30.5 22Z" fill="#c9a66b"/></g>`),
  scraper: wrap(
    `<path d="M5.5 35L18 22.5" stroke-width="7" stroke="#15110d" stroke-linecap="butt"/>
<path d="M5.5 35L18 22.5" stroke-width="3.6" stroke="#e8701a" stroke-linecap="butt"/>
<path d="M18 22.5C14 18 17 9 25 8C33 7 36 14 31 19C28 22 22 24 18 22.5Z" fill="#ffd36a" fill-opacity=".55" stroke-width="2.6"/>`),
  poker: wrap(
    `<path d="M5 36L15.5 25.5" stroke-width="9" stroke="#15110d" stroke-linecap="butt"/>
<path d="M5 36L15.5 25.5" stroke-width="5.2" stroke="#e8701a" stroke-linecap="butt"/>
<path d="M16 25L34.5 6.5" stroke-width="2.2"/><path d="M34.5 6.5L36 5" stroke-width="1"/>
<circle cx="28" cy="33" r="2.6" fill="#15110d" stroke="none"/><circle cx="34" cy="28" r="1.6" fill="#15110d" stroke="none"/>`),
  shapes: wrap(
    `<path d="M4 20L14 4L24 20Z" fill="#efe4cc"/><path d="M26 6L28.5 12L35 12.5L30 17L31.5 23.5L26 20L20.5 23.5L22 17L17 12.5L23.5 12Z" fill="#e8701a" transform="translate(2 8)"/><circle cx="12" cy="30" r="6" fill="#15110d"/>`),
  eraser: wrap(
    `<g transform="rotate(-20 20 20)"><path d="M5 13L35 13.5L35 27L5 26.5Z" fill="#efe4cc"/><path d="M5 13L16 13.2L16 26.7L5 26.5Z" fill="#e8701a"/></g>
<path d="M6 35L9 34M14 36L18 35M25 36L27 35.5" stroke-width="1.6"/>`),
  move: wrap(
    `<path d="M10 23L10.5 15.5L14.2 15.5L14.4 20L14.6 8L18.4 8L18.6 19L18.8 5.5L22.6 5.5L22.6 19L22.9 8.5L26.7 8.5L26.8 22L29.3 17L32.4 19L28.4 30L20.5 35L12.5 31Z" fill="#efe4cc"/>`),
  spin: wrap(
    `<circle cx="20" cy="21" r="9" fill="#efe4cc"/><path d="M20 12C16 15 16 27 20 30M20 12C24 15 24 27 20 30"/>
<path d="M5 14C9 5 25 3 33 9" stroke-width="2.2"/><path d="M33 3.5L33.5 9.5L27.5 10"/><path d="M35 28C31 37 15 38 7 32" stroke-width="2.2"/><path d="M7 37.5L6.5 31.5L12.5 31"/>`),
  points: wrap(
    `<path d="M5 31L15.5 14L29 22.5L34.5 7.5" stroke-width="1.8"/>
<rect x="2.8" y="28.8" width="4.6" height="4.6" fill="#efe4cc"/><rect x="13.2" y="11.8" width="4.6" height="4.6" fill="#e8701a"/>
<rect x="26.7" y="20.2" width="4.6" height="4.6" fill="#efe4cc"/><rect x="32.2" y="5.2" width="4.6" height="4.6" fill="#efe4cc"/>`),
};
